import { FC } from 'react';
import { Tooltip } from 'flowbite-react';

interface AvatarProps {
  imageUrl?: string | null;
  name: string;
  size?: 'sm' | 'md' | 'lg';
  showTooltip?: boolean;
}

export const Avatar: FC<AvatarProps> = ({ imageUrl, name, size = 'md', showTooltip = true }) => {
  // Size classes for different avatar sizes
  const sizeClasses = {
    sm: 'w-8 h-8 text-sm',
    md: 'w-10 h-10 text-base',
    lg: 'w-14 h-14 text-xl'
  };
  
  const sizeClass = sizeClasses[size];
  
  const avatarContent = imageUrl ? (
    <div className={`relative ${sizeClass}`}>
      <div className="absolute inset-0 rounded-full overflow-hidden">
        <img 
          src={imageUrl} 
          alt={`${name} avatar`}
          className="w-full h-full object-cover"
          style={{ aspectRatio: '1/1' }}
        />
      </div>
    </div>
  ) : (
    <div className={`rounded-full bg-cm-border-subtle flex items-center justify-center text-cm-text-muted font-medium ${sizeClass}`}>
      {name.charAt(0).toUpperCase()}
    </div>
  );

  return showTooltip ? (
    <Tooltip content={name} placement="bottom">
      {avatarContent}
    </Tooltip>
  ) : (
    avatarContent
  );
};

export default Avatar;
